import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const QRCodeGenerator = ({ value, size = 256, flagUrl }) => {
  return (
    <div style={{ position: 'relative', display: 'inline-block', padding: '16px', backgroundColor: '#ffffff' }}>
      {flagUrl && (
        <img 
          src={flagUrl} 
          alt="Country Flag" 
          style={{
            width: 32, 
            height: 32, 
            position: 'absolute', 
            top: 0, 
            left: '50%', 
            transform: 'translateX(-50%) translateY(-50%)'
          }} 
        />
      )}
      <QRCodeCanvas 
        value={value} 
        size={size} 
        bgColor="#ffffff" // Color de fondo blanco
        fgColor="#000000" // Color del QR negro
        level="H" // Nivel alto de corrección de errores
      />
    </div>
  );
};

export default QRCodeGenerator;
